import {
    EmailSubsectionChip,
    PersonChip,
    PhoneSubsectionChip,
    PlusIconsOptions,
    TrashOutlineIcon
} from '../../../../../components/buttons/IconButtons';
import {EMPTY_VALUES, getFullName} from '../../../../../Apis/functions';
import CustomCard from '../../../../../components/CustomCard';
import React from 'react';
import CustomChip from '../../../../../components/CustomChip';
import {useTranslation} from 'react-i18next';
import {colors} from '../../../../../enums/colors';
import {USER_TYPE_MODEL, userType} from '../../../../../enums/userTypeEnum';
import {toast} from 'react-toastify';
import CustomTooltip from '../../../../../components/CustomTooltip';
import {getUserTypeName} from '../Model/Models';
import {useSelector} from 'react-redux';
/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const UserCardDetails = (
    {
        item, usersSelected, setUsersSelected, optionInTable = true, setShowCreateNewVisitorModal, setVisitorSelected, disabled=false
    }
) => {
    const { t } = useTranslation();
    const allVisitorTypes = useSelector((state) => state?.EmployeeEventsSlice?.getAllVisitorTypes);
    const { getEventSetting } = useSelector((state) => state?.EmployeeEventsSlice);

    return (
        <div className={`${optionInTable ? '' : 'mb-2'}`}>
            <CustomCard
                classes="w-100"
                classCard="card-border-8px"
                classContent={`background-shades-50 ${disabled ? '' : 'background-hover-shades-100' }`}
            >
                <div className="row align-items-center justify-content-center">
                    <div className='col-11 p-0'>
                        <div className="row d-flex align-items-center justify-content-between">
                            <div className={`${optionInTable ? 'col-12' : 'col-6'} p-0  `}>
                                <div className='d-flex align-items-center'>
                                    <div><PersonChip className="mr-8px mb-1" /></div>
                                    <div className={"flex-grow-1 minw-0 p-0 m-0"}>
                                        <CustomTooltip
                                            text={getFullName(item.name, item.firstLastName, item.secondLastName)}
                                            classes={`fs-14px ${disabled ? 'font-color-shades-500' : 'font-color-general-950'} ibl-font-w-600 text-ellipsis-1-row `}
                                            showIfTruncated={true}
                                        />
                                    </div>
                                </div>
                            </div>
                            {!optionInTable &&
                                <div className="col-6 pl-4 pr-0 d-flex justify-content-end gap-1">
                                    {item?.visitorTypeId && (
                                        <CustomChip
                                            background={colors.secondary100}
                                            fontColor={colors.secondary700}
                                            borderColor={colors.secondary150}
                                            legend={getUserTypeName(item?.visitorTypeId, allVisitorTypes)}
                                            variant="compact"
                                        />
                                    )}
                                    <CustomChip
                                        background={colors.secondary100}
                                        fontColor={colors.secondary700}
                                        borderColor={colors.secondary150}
                                        legend={t(userType[item?.userTypeId || item?.userType?.id]) || EMPTY_VALUES.DEFAULT}
                                        variant="compact"
                                    />
                                </div>

                            }
                        </div>

                        <div className="border-bottom-shades-300 my-2" />
                        <div className='row align-items-center justify-content-between '>
                            <div className='col-6 p-0'>
                                <div className="d-flex align-items-center p-0 m-0">
                                    <div><EmailSubsectionChip className="mr-8px mb-1" /></div>
                                    <div className={"flex-grow-1 minw-0 p-0 m-0"}>
                                        <CustomTooltip
                                            text={item?.email}
                                            classes={`fs-14px font-color-general-950 text-ellipsis-1-row`}
                                            showIfTruncated={true}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='col-6 pl-3 pr-0'>
                                <div className="d-flex align-items-center p-0 m-0">
                                    <div><PhoneSubsectionChip className="mr-8px mb-1" /></div>
                                    <p className="fs-14px font-color-general-950">{item?.phoneNumber}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-1'>
                        {optionInTable
                            ?
                            <PlusIconsOptions
                                className={`icon-color-shades-400 ${disabled ? '' : 'icon-hover-shades-950'} `}
                                onClick={() => {
                                    if(disabled) return;
                                    if(getEventSetting?.attendeesLimitsEnabled &&
                                        usersSelected?.length === getEventSetting?.attendeesLimitsValue){
                                        toast.warn(t("limit_of_selections_reached"));
                                        return;
                                    }
                                    const exists = usersSelected.some(
                                        user => String(user.userId) === String(item.userId)
                                    );

                                    if (exists) {
                                        toast.warn(t("the_user_has_already_been_added"));
                                    } else {
                                        if (parseInt(item.userTypeId) === USER_TYPE_MODEL.VISITOR) {
                                            setVisitorSelected(item);
                                            setShowCreateNewVisitorModal(true);
                                        } else {
                                            setUsersSelected(prev => [...prev, item]);
                                        }
                                    }
                                }}
                            />
                            :
                            <TrashOutlineIcon
                                className='icon-color-shades-400 icon-hover-shades-950'
                                onClick={() => {
                                    setUsersSelected(prev => {
                                        return prev.filter(
                                            user => String(user.userId) !== String(item.userId)
                                        );
                                    });
                                    toast.success(t('has_been_deleted_successfully'));
                                }}
                            />
                        }
                    </div>
                </div>
            </CustomCard>
        </div>
    );

}
export default UserCardDetails
